import React from 'react';
import { Tag } from '@bedrock/components';
import { getDemandStateTagColor } from '#features/BudgetDetailTable/demandStateColor';

/**
 * 二级单 / 三级单状态 Tag（枚举 → 颜色，中文名直接展示）。
 * 复用预算看板 getDemandStateTagColor 三类语义：黄=需处理 / 蓝=进行中 / 灰=结束。
 * stateName 为空（未生成三级单等）显示 -- 占位。
 */
export const RechargeDemandStateTag: React.FC<{
  state?: string | null;
  stateName?: string | null;
}> = ({ state, stateName }) => {
  if (!stateName) {
    return <span className="text-color-3">--</span>;
  }
  return (
    <Tag
      text={stateName}
      size="small"
      color={getDemandStateTagColor(state)}
      // 外层 flex flex-col 容器默认 align-items:stretch 会把 Tag 拉伸到格子宽度；
      // self-start 让 Tag 按内容宽度撑开（Design Feedback 2026-08-25）
      className="self-start"
    />
  );
};

export default RechargeDemandStateTag;
